export default __webpack_public_path__ + "static/media/pictogramBeaconInternational48.7ff4634c.svg";